import React, { useEffect, useState } from "react";
import { Button, Modal } from 'antd';
import styles from "./scss/meetingslist.module.scss";
import { URButton } from "../../../shared/widgets/button";
import usrcirclegrey from "../../../styles/images/meetingusericon.svg";
import usrcircleactive from "../../../styles/images/PersonCirclewhite.svg";
import copyinvite  from "../../../styles/images/copyinvite.svg"
//*import { URInput } from "../../../shared/widgets/input";
//*import { Link } from "react-router-dom";
import { getMeetingLists, getVideoRecordingLists, scrollgetMeetingLists, updateMeetingRead } from "../../../base/meetingService/apiService";
import store from "../../../context/store/store";
import {
  convertDuration, createPlayList, fetchPlayLists, findHostName, playListDelete, searchMeetingDescriptionHighlight,
  searchMeetingHostNameHighlight,
  searchMeetingTitleHighlight,
  setClipsToPlayList,
  timeStampConverterMeeting
} from "../../../base/callService/common";
import moment from "moment";
import Lottie from "lottie-react";
import groovyWalkAnimation from "../../../styles/images/chat blank state loading.json";
import ContactLoader from "../../../styles/images/Lottie Animation.json";
import { URChatLeftSkeleton } from "../../../shared/skeletonLoading/chatLeftSkeleton";
//*import { copyTemplate } from "../../../base/meetingService/utils";
import { ccTabChange, storeActions, storeCurrentMeetingDetail, storeEditMOM, storeEditMOMCopy, storeMeetingPage, storeMOM, storePlayListPage, storePreviousMeetingDetail, storeTranscript, storeVideoRecordingList, storeWindowState } from "../../../base/meetingService/meetingStoreServices";
import { useSelector } from "react-redux";
import { LoginState } from "../../../models/model";
import { RRuleTimeCal } from "../../../base/meetingService/utils/meetingServices";
import CopyInvitePopUp from "../meetingWidgets/popUp/copyInvitePopUp";
import _ from "lodash";
//import { isConditionalExpression } from "typescript";
import NoContent from "../../../shared/widgets/noContent";
import noResult from "../../../styles/images/empty_states/nomeetingsfound.svg";
import { UserDetails } from "../../../models/model";
import { useHistory } from "react-router-dom";
import { Types } from "../../../context/action/action";
// import recordVid1 from "../../../styles/images/recordedRed.svg";
import recVid from "../../../styles/images/recordedRed.svg";
import style from "./scss/leftsidebar.module.scss";


type meetListState = {
  isClear: boolean;
  meetingListState: any;
  filterType: string;
  tempList: any;
  doneList: any;
  isModalVisible: boolean;
  isCopyModal: boolean;
  // notifyStatus: boolean;
  // audioStatus: boolean;
};

const PlayLists = React.memo(() => {
  const [meetListState, setMeetListState] = useState<meetListState>({
    isClear: false,
    meetingListState: [],
    filterType: "Upcoming",
    tempList: [],
    doneList: [],
    isModalVisible: false,
    isCopyModal: false
    // notifyStatus: false,
    // audioStatus:false
  });
  

 
  const history = useHistory();
  let { meetingList, isLeftBarLoading, detailPage,currentMeetingDetailPage } = store.getState().meetingReducer || [];

  let { meetingReducer }: any = useSelector((state: any) => state);
  let { getListInput,playLists,updatePlayList } = meetingReducer;
  console.log("playLists+++",playLists)
  console.log("updatePlayList+++",updatePlayList)

  let { userdetails }: LoginState = store.getState().loginReducer;
  let previousMeetingArray: any = ['Completed', 'Missed', 'Cancelled'];
  let { isModalVisible, isCopyModal } = meetListState;
  const loggedUser: UserDetails = store.getState().loginReducer.userdetails || [];
  //var travelTime = (moment(detailPage.lastModifiedDate).add(1, 'hours').format('hh:mm A')).split(" ");
  //console.log('loggedUser.sip_login_id --- ', loggedUser.sip_login_id);
 
  const [confirmModal,setConfirmModal] = useState(false);
  const [confirmSingleModal,setConfirmSingleModal] = useState(false);
  const [deleteId,setDeleteId] = useState(false);
  const [deletedClips,setdeletedPlayList]=useState<any>([]);
  const [playlistModal,setPlaylistModal] = useState(false);
  const [title,setTitle] = useState("");
  const [description,setDescription] = useState("");
  const [playListId,setPlayListId] = useState(0)



  const handleCancel = () => {
    setMeetListState({ ...meetListState, isModalVisible: false });

  };

  const copyInvitationModal = (status:boolean) => {
    setMeetListState({ ...meetListState, isCopyModal: status });
  };
  
  // const handleOk3 = () => {
  //   copyTemplate('copyMeeting');
  //   toastInformation('Meeting invitation copied', 'success');
  //   setMeetListState({ ...meetListState, isCopyModal: false });
  // };
  // const handleCancel3 = () => {
  //   setMeetListState({ ...meetListState, isCopyModal: false });
  // };



 




  const storeMeetingDetail = (list: any) => {
    // storeMeetingPage(list);
    storeMOM([],[],[],[], true);
    storeTranscript([],false,0);
    storeEditMOM("",false);
    storeEditMOMCopy("",false);
    ccTabChange("1");
      history.push("/meeting")
      let recdata: any ={};
      recdata.offset = 0;
      recdata.limit = 10;
      recdata.search = list.uuid;
      getVideoRecordingLists(recdata);
    if (!_.isEmpty(currentMeetingDetailPage)) {
      storePreviousMeetingDetail(currentMeetingDetailPage)
      storeMeetingPage(list)
      storeCurrentMeetingDetail(list)
    }
    else{
      storeCurrentMeetingDetail(list);
      storeMeetingPage(list)
    }
  }


  useEffect(()=>{
    fetchPlayLists();
    console.log("playLists===",playLists)
    console.log("Array.isArray(playLists) && playLists.length > 0 ",Array.isArray(playLists) , playLists.length > 0 )
   // updateMeetingTotalBatch();
    //console.log('meetingList test ------',meetingList)
    //console.log('meetingTotalCount -----', meetingTotalCount)
  },[JSON.stringify(playLists)])

  const redirectToMeeting = (elem:any) => {
    if (!previousMeetingArray.includes(elem.status)) {
      let replaced_url: any= elem.invite_url?.includes("stagemeet") ? `${elem.invite_url}${elem?.meetings_type === 1 ? "?type=meetnow" : ""}`: `${elem.invite_url?.replace('meet.unifiedring', 'meet.worktual')}${elem?.meetings_type === 1 ? "?type=meetnow" : ""}`;
     window.open(replaced_url, '_blank'); 
     store.dispatch({
      type: Types.VIDEOMEET_COUNT_STATUS,
      payload: {
        meetingCountStatus:true
      }
    })
    updateMeetingRead(elem?.uuid);
    }
    else return false;
  };
  
  const reScheduleMeeting = (elem: any) => {
    storeMeetingPage(elem);
    storeWindowState("reschedule"); 
  };
    console.log("getListInput",getListInput);
    
    const setDetail = (list:any) =>{
        // storeWindowState('playList');
        //1 =>latest to oldest
        //2 =>oldest to Latest
        setClipsToPlayList(list?.playlist_id,1);
        setPlayListId(list?.playlist_id)
        setTitle(list?.playlist_name);
        setDescription(list?.playlist_desc)
        // storePlayListPage(list);

    }


    const openConfirmModal = () =>{
      setConfirmModal(true)
      // setDeleteId(id);
      // deleteClips(id);
    }
    const closeConfirmModal = () =>{
      setConfirmModal(false)
    }

    const openConfirmSingleModal = (id?:any) =>{
      setConfirmSingleModal(true)
      setDeleteId(id);
      // deleteClips(id);
    }
    const closeConfirmSingleModal = () =>{
      setConfirmSingleModal(false)
    }
  

    const deleteClips =() =>{
      let id:any = deleteId;
      setdeletedPlayList(id);
      // playListDelete(id);
      setConfirmSingleModal(false);
    }

    const openPlaylistModal = () =>{
      setPlaylistModal(true)
    }
    const closePlaylistModal = () =>{
      setPlaylistModal(false)
    }

    const openPlayList =()=>{
      console.log("create clips")
      let loggedUserDetails: UserDetails =
      store.getState().loginReducer.userdetails || [];
      let data: any = {
        playlist_id:null,
        playlist_name:title,
        playlist_desc:description,
        clip_record_id:[]
    
        // id: recordDetailPage.v_id,
        // meeting_id: recordDetailPage.meeting_id,
        // title: title,
        // description: description,
        // startPoint: timeStringToSeconds(formatTime(trimStart)),
        // endpoint: timeStringToSeconds(formatTime(trimEnd)),
        // inputStream: recordDetailPage.record_url,
        // ext: loggedUserDetails.ext,
        // duration: calculateDurationInSec(),
        // size: recordDetailPage.record_size
      };
    
      // createClip(data);
      // closeModalClip();
      // createPlayList(data);
      closePlaylistModal();
      
    
    }
    
    const editPlayList =()=>{
      console.log("create clips")
      let loggedUserDetails: UserDetails =
      store.getState().loginReducer.userdetails || [];
      let data: any = {
        playlist_id:playListId,
        playlist_name:title,
        playlist_desc:description,
        clip_record_id:[]
    
        // id: recordDetailPage.v_id,
        // meeting_id: recordDetailPage.meeting_id,
        // title: title,
        // description: description,
        // startPoint: timeStringToSeconds(formatTime(trimStart)),
        // endpoint: timeStringToSeconds(formatTime(trimEnd)),
        // inputStream: recordDetailPage.record_url,
        // ext: loggedUserDetails.ext,
        // duration: calculateDurationInSec(),
        // size: recordDetailPage.record_size
      };
    
      // createClip(data);
      // closeModalClip();
      createPlayList(data);
      closePlaylistModal();
      
    
    }
  return (
    <>
    <div className={`${styles.scrolllayerleft} ${"scrollerhover"}`}>
    <>
    {Array.isArray(playLists) && playLists.length > 0 ? 
    <>
           <div className={`${styles.meetingsList}`}>
           {playLists?.map((list: any, index: any) => {
              console.log("editPlayList",playLists)
              const currentTimeStamp=Date.now(); 
              const subTimpstampval= list.start_timestamp-currentTimeStamp;
              const diffTimeStamp=Math.floor(subTimpstampval/60000);
              var diffval = diffTimeStamp<=0 ? 100 : diffTimeStamp;
              let titleMessage: any = searchMeetingTitleHighlight(list, getListInput.searchText);
              let descriptionMessage: any = searchMeetingDescriptionHighlight(list, getListInput.searchText);
              let hostMessage: any = searchMeetingHostNameHighlight(list, getListInput.searchText);
              if(list.ReadFlag){
                var readFlagStatus = list?.ReadFlag[loggedUser?.sip_login_id];
                //console.log("readFlagStatus>>>>>",readFlagStatus);
              }
            return(
                // <div className="Dividerchild" key={index}>
                //     <p>{list?.playlist_name}</p>
                // </div>
                // <div className="Dividerchild" key={index} >
                //     <div className={styles.meetingclickingarea} onClick={() => setDetailPage(list)}>  
                //     {(getListInput?.searchText !== "") ? 
                //         <div className={styles.meetingsTitle}>
                //             <p className={styles.desleftsidetoptitle}>{(titleMessage?.middleMsg !== "") ? <>{titleMessage?.firstMsg}
                //             < span className={styles.highlight}>{titleMessage?.middleMsg}</span>{titleMessage?.lastMsg}</> :
                //             <>{list?.playlist_name}</>}</p>
                //             <p className={styles.desleftsidemiddle}>{(descriptionMessage?.middleMsg !== "") ? <>{descriptionMessage?.firstMsg}
                //                 < span className={styles.highlight}>{descriptionMessage?.middleMsg}</span>{descriptionMessage?.lastMsg}</> :
                //                 <>{list?.playlist_desc}</>}</p>
                //         </div> :
                //         <> <div className={styles.meetingsTitle}>
                //         <span className={styles.mt}>{list.playlist_name}</span>
                //         {/* {list.rrule !==""   &&   <span className={styles.recType}>
                //         <span className="icon_flipfill"></span>
                //         {list.rrule.includes("FREQ=DAILY")
                //         ? "Daily" : list.rrule.includes("FREQ=WEEKLY")
                //             ? "Weekly" : list.rrule.includes("FREQ=MONTHLY")
                //             ? "Monthly" : "None"}</span>} */}
                //         </div>
                //         </>
                //         }
                
                //     </div> 
                // </div>                                                      

                <div className="Dividerchild" key={index} >
                {/* {
                  moment(list.start_timestamp).format('YYYY/MM/DD') !==
                  moment(meetingList[index - 1]?.start_timestamp).format('YYYY/MM/DD') &&
                  // <Divider plain className="dividerDate">{timeStampConverter(list.start_timestamp, 'group')}</Divider>     
                  <div className={styles.badgecurrentmeet}>
                    <div className={styles.badmidlesec}>
                        <span>{timeStampConverterMeeting(list.start_timestamp, 'group')}</span>
                    </div>
                </div>

                } */}
                  {/* { index === 0 && moment(list.start_timestamp).format('YYYY/MM/DD') ===   moment(new Date()).format('YYYY/MM/DD')&& <div className={styles.badgecurrentmeet}>
                <div className={styles.badmidlesec}>
                        <span>Today</span>
                    </div>
                </div>} */}


                <div>
                  <div className={styles.meetingclickingarea} 
                //   onClick={() => setDetailPage(list)}
                onClick={ ()=>setDetail(list)}
                 >                                                            
                    {/* <div className={styles.meetingsTime}>{
                      (diffval <= 5 && list.status === "Cancelled" && (list.status !== "Ongoing Meeting" || list.status === "Missed" || list.status ==="Completed")) ? <label className={`${styles.meetingsTime} ${styles.in5mins}`}>In 5 minutes</label>
                       : (diffval <= 15 && list.status === "Cancelled" &&  (list.status !== "Ongoing Meeting" || list.status === "Missed" || list.status ==="Completed")) ? <label className={`${styles.meetingsTime} ${styles.in15mins}`}>In 15 minutes</label> : 
                    (moment(list.start_timestamp).format('hh:mm A')) + ' - ' +
                (moment(list.rrule !== "" ? RRuleTimeCal(list.start_timestamp, list.duration_minutes) : list.end_timestamp).format('hh:mm A'))
                }
                      {(previousMeetingArray.includes(list.status) || list.status === "Ongoing Meeting") &&
                        <div className={styles.meetingSts} >{list.status}</div>}
                        
                        </div> */}
                      {/* {readFlagStatus===1 && list.status !=="Completed" &&  <span className={styles.unReaddot}></span>} */}
                    {(getListInput?.searchText !== "") ? <div className={styles.meetingsTitle}>

                      <p className={styles.desleftsidetoptitle}>{(titleMessage?.middleMsg !== "") ? <>{titleMessage?.firstMsg}
                        < span className={styles.highlight}>{titleMessage?.middleMsg}</span>{titleMessage?.lastMsg}</> :
                        <>{list?.playlist_name}</>}</p>
                        <p className={styles.desleftsidemiddle}>{(descriptionMessage?.middleMsg !== "") ? <>{descriptionMessage?.firstMsg}
                          < span className={styles.highlight}>{descriptionMessage?.middleMsg}</span>{descriptionMessage?.lastMsg}</> :
                          <>{list?.playlist_desc}</>}</p>
                    </div> :
                      <> <div className={styles.meetingsTitle}>
                          <span className={styles.mt}>{list.playlist_name}</span>
                           <span><img src={recVid} alt="record video"/> {list?.count} Clips</span>
                        
                       
                        
                      {/* {list.rrule !==""   &&   <span className={styles.recType}>
                      <span className="icon_flipfill"></span>
                      {list.rrule.includes("FREQ=DAILY")
                        ? "Daily" : list.rrule.includes("FREQ=WEEKLY")
                          ? "Weekly" : list.rrule.includes("FREQ=MONTHLY")
                            ? "Monthly" : "None"}</span>} */}
                            </div>
                      </>
                    }
                    <div className={styles.meetingsTime}>
                    <span className={styles.mt}>{list.playlist_desc}</span>
  
                    </div>
                    <div className={styles.meetingsBottomDet}>
                      <div className={styles.userName}>
                        {/* <img className={styles.greyImg} src={usrcirclegrey} alt="" /> */}
                        <img className={styles.actveImg} src={usrcircleactive} alt="" />
                        {(hostMessage?.middleMsg !== "" && getListInput?.searchText !== "") ?
                          (<>{hostMessage?.firstMsg}<span className={styles.highlight}>{hostMessage?.middleMsg}</span>{hostMessage?.lastMsg}</>)
                          :(<span> {!_.isUndefined(findHostName(list)) ? (findHostName(list)) : (list.sip_id=== userdetails.sip_login_id) ? "You": list.hostName }</span>)
                        }
                      </div>
                      <div className={styles.meetingSts}>
                        <div style={{display:'flex',gap:'10px'}}>
                           <div onClick={openPlaylistModal}>
                            edit
                           </div>
                          <div  
                          // onClick={openMultiShare}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="12"
                              height="12"
                              viewBox="0 0 12 12"
                              fill="none"
                            >
                              <path
                                d="M10.8443 3.05956L10.3789 2.61229C9.41081 1.68262 8.78415 1.09669 8.24868 0.808224C7.74448 0.537424 7.18295 0.547157 6.70601 0.83429C6.43548 0.998357 6.24635 1.25549 6.12595 1.62462C6.03675 1.90849 5.98828 2.26396 5.96515 2.82256C3.28088 2.91562 0.0244141 3.57062 0.0244141 7.24896C0.0244141 9.10309 1.42808 10.8167 2.72721 11.3414C2.80501 11.3727 2.88675 11.3883 2.96748 11.3883C3.13021 11.3883 3.28975 11.3258 3.41021 11.2086C3.59055 11.0328 3.64981 10.7666 3.56128 10.5302C3.03135 9.11489 2.95548 8.15782 3.32888 7.60442C3.68175 7.08162 4.52681 6.79456 5.97148 6.71056C5.99461 7.28936 6.04795 7.71576 6.17881 8.05236C6.31908 8.41562 6.59741 8.69296 6.96235 8.83429C7.35721 8.98662 7.80835 8.96256 8.19541 8.76916C8.75528 8.49569 9.38975 7.88962 10.3849 6.93842L10.8527 6.48922C11.5213 5.84662 11.8895 5.49249 11.9607 4.97422C11.9799 4.84142 11.9799 4.70209 11.9614 4.57449C11.8898 4.05302 11.5237 3.70542 10.8443 3.05956ZM10.9703 4.83429C10.9459 5.01269 10.6331 5.31349 10.1578 5.76982L9.65848 6.24902C8.79815 7.07129 8.17668 7.66569 7.75221 7.87269C7.61388 7.94169 7.45401 7.95149 7.32288 7.90196C7.22135 7.86222 7.15001 7.79196 7.11095 7.69036C6.99895 7.40262 6.96868 6.87982 6.95761 6.18256C6.95535 6.04909 6.90001 5.92216 6.80395 5.82969C6.70761 5.73789 6.57475 5.68122 6.44521 5.69036C4.28441 5.74442 3.10475 6.14936 2.49988 7.04516C2.03861 7.72809 1.97255 8.64669 2.30455 9.89349C1.60728 9.26396 1.02428 8.24962 1.02428 7.24896C1.02428 4.86682 2.58615 3.86942 6.41295 3.81209C6.55648 3.82249 6.70528 3.77109 6.81108 3.66496C6.92275 3.55362 6.97321 3.39802 6.95335 3.24636L6.95728 3.06536C6.96835 2.68122 6.99181 2.20402 7.07808 1.92996C7.13995 1.74049 7.20441 1.70142 7.22328 1.68969C7.39615 1.58556 7.58235 1.58616 7.77535 1.68902C8.19688 1.91622 8.80561 2.48782 9.68615 3.33356L10.1709 3.79902C10.638 4.24302 10.9466 4.53602 10.971 4.71436C10.9765 4.75082 10.9765 4.79329 10.9703 4.83429Z"
                                fill="#3E3F40"
                              />
                            </svg>
                          </div>
                          <div onClick={()=> openConfirmSingleModal(list?.playlist_id)}>  
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="12"
                              height="14"
                              viewBox="0 0 12 14"
                              fill="none"
                            >
                              <path
                                d="M4.92031 10.9562C4.64424 10.9562 4.42031 10.7323 4.42031 10.4562V4.74305C4.42031 4.46698 4.64424 4.24305 4.92031 4.24305C5.19638 4.24305 5.42031 4.46698 5.42031 4.74305V10.4562C5.42031 10.7323 5.19638 10.9562 4.92031 10.9562Z"
                                fill="#3E3F40"
                              />
                              <path
                                d="M7.08044 10.9562C6.80438 10.9562 6.58044 10.7323 6.58044 10.4562V4.74305C6.58044 4.46698 6.80438 4.24305 7.08044 4.24305C7.35651 4.24305 7.58044 4.46698 7.58044 4.74305V10.4562C7.58044 10.7323 7.35651 10.9562 7.08044 10.9562Z"
                                fill="#3E3F40"
                              />
                              <path
                                d="M11.447 1.97645H8.81351V1.56985C8.81351 0.864117 8.25751 0.289917 7.57391 0.289917H4.42024C3.73664 0.289917 3.18031 0.864117 3.18031 1.56985V1.97645H0.553711C0.277644 1.97645 0.0537109 2.20038 0.0537109 2.47645C0.0537109 2.75252 0.277644 2.97645 0.553711 2.97645H0.956578L1.46811 11.4055C1.54298 12.6979 2.61718 13.7102 3.91378 13.7102H8.07391C9.36951 13.7102 10.4496 12.6965 10.5329 11.4003L11.0448 2.97652H11.447C11.723 2.97652 11.947 2.75258 11.947 2.47652C11.947 2.20045 11.723 1.97645 11.447 1.97645ZM4.18038 1.56985C4.18038 1.41558 4.28811 1.28992 4.42031 1.28992H7.57398C7.70611 1.28992 7.81358 1.41558 7.81358 1.56985V1.97645H4.18044L4.18038 1.56985ZM9.53485 11.3378C9.48538 12.1073 8.84344 12.7102 8.07391 12.7102H3.91378C3.14651 12.7102 2.51044 12.1119 2.46618 11.3463L1.95831 2.97645H10.0424L9.53485 11.3378Z"
                                fill="#3E3F40"
                              />
                            </svg>
                          </div>
                        </div>
                        
                        
               
                      </div>
                      {/* {(previousMeetingArray.includes(list.status) || list.status === "Ongoing Meeting") &&
                        <div className={styles.meetingSts} onClick={() => redirectToMeeting(list)}>{list.status=== "Ongoing Meeting" ?
                        "Ongoing" : list.status}</div>} */}
                
                    </div>
                  </div>

                  {/* {(list.status === "Start" || list.status === "Join" || list.status === "Cancelled" || list.status==="Ongoing Meeting" || list.status === "Missed" || list.status==="Rejoin") &&
                    <div className={(list.status === "Cancelled" ||list.status === "Missed") ? `${styles.copyInvite} ${styles.reschedule}` : `${styles.copyInvite}`} onClick={() => storeMeetingDetail(list)}>
                      {!previousMeetingArray.includes(list.status) &&
                        <div className={styles.duration} onClick={() => copyInvitationModal(true)}>
                          <span><img src={copyinvite} alt="" /></span>Copy Invitation</div>}
                      <div className={styles.join}>
                        {(!previousMeetingArray.includes(list.status) && (list.status !== "Ongoing Meeting") && (list.status !== "Rejoin"))  &&<URButton className='buttonBlue joinBtn' name={
                          userdetails.sip_login_id === list.sip_id ? "Start" : "Join"
                        } onClick={() => redirectToMeeting(list)}></URButton>}
                        {list.status === "Ongoing Meeting" && <URButton className='buttonBlue joinBtn' name={"Join"
                        } onClick={() => redirectToMeeting(list)}></URButton>}
                        {
                          list.status === "Rejoin" && <URButton className='buttonBlue joinBtn' name={"Re-join"
                        } onClick={() => redirectToMeeting(list)}></URButton>
                        }
                        {(list.status === "Cancelled" || list.status ==="Missed") && userdetails.sip_login_id === list.sip_id &&
                          <URButton className='buttonBlue joinBtn' name={
                            userdetails.sip_login_id === list.sip_id && "Reschedule"
                          } onClick={()=>reScheduleMeeting(list)}></URButton>}
                      </div>
                    </div>
                  } */}
                  {/* {(list.status === "Start" || list.status === "Join" ||list.status==="Ongoing Meeting" || list.status==="Rejoin") &&
        <div className={`${styles.copyInvite}`} onClick={() => storeMeetingDetail(list)}>
            {!previousMeetingArray.includes(list.status) &&
                        <div className={styles.duration} onClick={() => copyInvitationModal(true)}>
                          <span><img src={copyinvite} alt="" /></span>Copy Invitation</div>}
                          <div className={styles.join}>
                        {(!previousMeetingArray.includes(list.status) && (list.status !== "Ongoing Meeting") && (list.status !== "Rejoin"))  &&<URButton className='buttonBlue joinBtn' name={
                          userdetails.sip_login_id === list.sip_id ? "Start" : "Join"
                        } onClick={() => redirectToMeeting(list)}></URButton>}
                        {list.status === "Ongoing Meeting" && <URButton className='buttonBlue joinBtn' name={"Join"
                        } onClick={() => redirectToMeeting(list)}></URButton>}
                        {
                          list.status === "Rejoin" && <URButton className='buttonBlue joinBtn' name={"Re-join"
                        } onClick={() => redirectToMeeting(list)}></URButton>
                        }
                      </div>
          </div>
                  }
                                   {(list.status === "Cancelled" ||list.status === "Missed") && userdetails.sip_login_id === list.sip_id &&
        <div className={`${styles.copyInvite} ${styles.reschedule}`} onClick={() => storeMeetingDetail(list)}>
                           {
                          <URButton className='buttonBlue joinBtn' name={
                            userdetails.sip_login_id === list.sip_id && "Reschedule"
                          } onClick={()=>reScheduleMeeting(list)}></URButton>}
          </div>
                  } */}
                </div>
                {/* <Modal
              centered
              visible={confirmModal}
              title="Delete Clips"
              onCancel={closeConfirmModal}
              className="cv modallnewst reacreateclipmodal"
              footer={[
                <>
                  <Button key="Cancel" className="ShareClipscancel" onClick={closeConfirmModal}>Cancel</Button>
                  <Button key="OK" className="ShareClipsbtn"  onClick={multiDelete}>Delete</Button>
                </>
              ]}
            >
              <div>
                <div className={styles.recreateclipmodalbody}>
                <p>{"Are you sure you want to delete ? Once deleted, you'll need to recreate the clip."}</p>
                </div>
              </div>
            </Modal> */}
              

                
                </div>
                
                
            )
           })}
           </div>
    </>:''}
    </>
        <Modal
              centered
              visible={playlistModal}
              title = "Edit Playlist"
              onCancel={closePlaylistModal}
              className="cv modallnewst"
              onOk={editPlayList}> 
              
              <div>
              <div className={style.ppmetricssectionn}>
                <div >
                 <div className={style.modalrow}>
                    <label>
                       Title Name <span>*</span>
                    </label>
                    <input type="text" 
                   value={title}
                   onChange={(e)=>setTitle(e.target.value)}
                   placeholder="Enter title name" ></input>
                  </div>
                  <div className={style.modalrow}>
                    <label>
                       Description 
                     </label>
                     <textarea 
                   value={description}
                   onChange={(e)=>setDescription(e.target.value)}
                   placeholder="Enter description"></textarea>
                   </div>
                </div>
              </div>
              </div>
        </Modal>
            <Modal
              centered
              visible={confirmSingleModal}
              title="Delete Clip"
              onCancel={closeConfirmSingleModal}
                className="cv modallnewst reacreateclipmodal"
              footer={[
                <>
                  <Button key="Cancel" className="ShareClipscancel " onClick={closeConfirmSingleModal}>Cancel</Button>
                  <Button key="OK" className="ShareClipsbtn  multideleteclipbtn"  onClick={deleteClips}>Delete</Button>
                </>
              ]}
            >
              <div>
                <div className={`${styles.ppmetricssectionn} ${styles.deleteClipsnewwbosy}`}>
                  <p>{"Are you sure you want to delete ? Once deleted, you'll need to Recreate the PlayList."}</p>
                </div>
              </div>
            </Modal>
    </div>
    </>
  );
});
          
        

export default PlayLists;